import React,{Component} from 'react';
import {createMarkup} from './Factory';
import {UISref} from 'ui-router-react'; 

class KalenderDetails extends Component {
	constructor(props) {
		super(props);
		this.handleClick = this.handleClick.bind(this);	
	}
	handleClick(){
		let {event_start_date,event_end_date,title,event_anmelden,event_perform,event_start_time} = this.props;
		let $date = event_start_date;
		if(event_end_date){
			$date += ` - ${event_end_date}`
		}
		let event_title = title.rendered;
		let $data = [event_title,$date,event_perform,event_anmelden,event_start_time];
		this.props.handleClick($data);
	}
	render(){				
		const { title,content,event_start_date,event_end_date,associate_taxonomy,event_anmelden,admin_email,
				event_start_time,event_end_time
		} = this.props;
		const {label_anmelden,label_clock} = this.props.staticData;
		let event_date = `${event_start_date}`;
		if(event_end_date!==''){
			event_date = event_date+"-"+event_end_date;
		}
		let $time = ` - ${event_start_time}`;
		if(event_end_time){
			$time += ` - ${event_end_time}`
		}
		let $event_anmelden = '';
		if(event_anmelden==='1' || event_anmelden==='3'){
			$event_anmelden = 
				<a className="btn dark-btn open-overlay" onClick={this.handleClick}>
					{label_anmelden}
				</a>
		}
		if(event_anmelden==='2'){
			let $body = '';
			if(document.language==='en'){
				$body = `
								Dear TAXISPALAIS-Team,%0D%0A %0D%0A

								I would like to register for the following event:%0D%0A %0D%0A
								${event_start_date}, ${title.rendered}.%0D%0A %0D%0A

								Best regards
							`;
			}else{ 
				$body = `
						Liebes Taxispalais-Team,%0D%0A %0D%0A

						hiermit möchte ich mich zur Veranstaltung ${title.rendered} am ${event_start_date} anmelden.%0D%0A %0D%0A

						Mit freundlichen Grüßen
						`;
			}
			let $subject = `${event_start_date} ${title.rendered}`;
			$event_anmelden = 
				<a className="btn dark-btn open-overlay" href={`mailto:${admin_email}?subject=${$subject}&body=${$body}`}>
					{label_anmelden}
				</a>
		}
		return(
				<div>
					 <h1 className="margin-top-0" dangerouslySetInnerHTML={createMarkup(title.rendered)}></h1>
					 <div className="event-date">
						<time>{event_date} {$time} {label_clock}</time>						
						{
							associate_taxonomy.map( (data,i)=>								 
								<span key={i} className="event-cat">
									<span> – </span>
									<UISref to="root.programm.kalender-kategorie.name" params={{item:data.slug}} >	
										<a>{data.name}</a>
									</UISref>	
								</span>
							)
						}
					</div>
					 <div role="article" className="content margin-top-40 md-txt max_900">
						<div dangerouslySetInnerHTML={createMarkup(content.rendered)}></div>
						{$event_anmelden}
					 </div>
				</div>
		)
	}
}
export default KalenderDetails;




// WEBPACK FOOTER //
// ./src/components/KalenderDetails.js